import { useOfflineSync } from '../hooks/useOfflineSync';
import { WifiOff, Wifi, Upload } from 'lucide-react';

export function OfflineIndicator() {
  const { isOnline, queue } = useOfflineSync();

  if (isOnline && queue.length === 0) return null;

  return (
    <div
      className={`fixed bottom-16 left-4 z-50 flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium shadow-lg transition-all ${
        isOnline ? 'bg-amber-600 text-white' : 'bg-red-600 text-white'
      }`}
      data-testid="offline-indicator"
    >
      {isOnline ? (
        <>
          <Upload className="h-3.5 w-3.5 animate-pulse" />
          Syncing {queue.length} queued action{queue.length !== 1 ? 's' : ''}...
        </>
      ) : (
        <>
          <WifiOff className="h-3.5 w-3.5" />
          Offline - actions will sync when reconnected
          {queue.length > 0 && <span className="ml-1">({queue.length} queued)</span>}
        </>
      )}
    </div>
  );
}
